/**
 * Normalisiert bekannte, versehentlich abweichende Blog-Content-URLs aus dem
 * Google-Sheet, ohne die externe Quelle zu verändern.
 *
 * Die beiden Beiträge vom 30.08.2026 verweisen aktuell auf eine Apps-Script-
 * Deployment-ID mit `F61VZc1`. Das aktive Deployment verwendet `F61YZc1`.
 * Die Korrektur bleibt auf die vollständige bekannte Deployment-ID begrenzt.
 */
const BROKEN_BLOG_DEPLOYMENT_ID =
  "AKfycbw21hcCHBpYoLrKIqS34snkDe7vjEpfeF61VZc1EHt-YIolNNKHrmW-QuBphFoMtNStdQ";
const ACTIVE_BLOG_DEPLOYMENT_ID =
  "AKfycbw21hcCHBpYoLrKIqS34snkDe7vjEpfeF61YZc1EHt-YIolNNKHrmW-QuBphFoMtNStdQ";

export function normalizeBlogContentUrl(url: string): string {
  if (!url) return "";
  return url.replace(BROKEN_BLOG_DEPLOYMENT_ID, ACTIVE_BLOG_DEPLOYMENT_ID);
}

export const blogContentUrlRepair = {
  brokenDeploymentId: BROKEN_BLOG_DEPLOYMENT_ID,
  activeDeploymentId: ACTIVE_BLOG_DEPLOYMENT_ID,
} as const;
